const servers = 20507;
const capacity = 23993.19;
const countries = 148;
const locations = 194;
export { servers, capacity, countries, locations };
